<template>
  <div class="one-column-view bg-green">
    <div class="article-content nft-content">
      <img
        src="../assets/GEMA-token-banner.png"
        alt="GEMA Token Banner"
        class="w-100"
      />
      <div
        class="d-flex flex-column-reverse flex-md-row justify-content-around align-items-center mb-3"
      >
        <div class="w-100 w-md-65 p-0 p-md-3">
          <h1>Grab up to 10,000 GEMA NFT tokens</h1>
          <p>
            Obtaining a GEMA, Global Exclusive Marketing Agent, will greatly
            enhance GSG”s high-level entry benefit. With a GEMA certificate, you
            will be able to leverage your network connections and establish a
            community to boost your business sales conversions. If you ever feel
            overwhelmed or simply want to streamline the process, you can
            acquire an NFT GEMA Token to link your authentic GEMA certification
            to an auction or sell it completely.
          </p>
          <div class="nft-btns">
            <router-link to="nft-gsg" class="btn GSG-btn">GSG</router-link>
            <div class="btn GEMA-btn">GEMA</div>
          </div>
        </div>
        <div class="w-100 w-md-35 p-0">
          <img src="../assets/GEMACoins.png" alt="GEMA" class="m-0 mx-auto" />
        </div>
      </div>
      <div class="nft-token-section">
        <div
          class="d-flex flex-column flex-md-row justify-content-around align-items-center"
        >
          <div class="w-100 w-md-50">
            <img
              src="../assets/GEMA-00278.png"
              alt="GEMA 00278"
              class="m-0 mx-auto w-100"
            />
          </div>
          <div class="w-100 w-md-50 px-1 px-md-4">
            <h1>NFT GEMA Token #00278</h1>
            <h5>NFT Description</h5>
            <div class="d-flex flex-column flex-md-row justify-content-between">
              <span class="color-gold my-1"
                >Total Supply <strong>10,000</strong></span
              >
              <span class="color-gold my-1"
                >Available <strong>1,000</strong></span
              >
            </div>
            <div class="d-flex justify-content-between">
              <div class="w-50 d-flex flex-column justify-content-between">
                <p class="m-0 w-100 text-white" @click="changeMintType('og')">
                  <input type="radio" id="og" name="mintType" value="og" checked><label for="og" class="ms-2"><strong>OG</strong></label>
                </p>
                <p class="m-0 w-100 text-end text-white pe-5">200</p>
              </div>
              <div class="w-50 text-end px-2">
                <p class="mb-2 text-white">(15 Referrals required )</p>
                <div class="d-flex mb-2 justify-content-between">
                  <p class="m-0">Ended</p>
                  <p class="m-0">9:00 AM 07/18</p>
                </div>
                <div class="d-flex justify-content-between">
                  <p class="m-0 text-white">
                    <img
                      src="../assets/Ethereum-icon-purple.png"
                      alt="Ethereum Icon"
                      class="m-0 d-inline w-auto"
                    /><span>0</span>
                  </p>
                  <p class="m-0 text-white">1 PER WALLET</p>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <div class="w-50 d-flex flex-column justify-content-between">
                <p class="m-0 w-100 text-white" @click="changeMintType('whitelist')">
                  <input type="radio" id="whitelist" name="mintType" value="whitelist"><label for="whitelist" class="ms-2"><strong>Whitelist</strong></label>
                </p>
                <p class="m-0 w-100 text-end text-white pe-5">400</p>
              </div>
              <div class="w-50 text-end px-2">
                <p class="mb-2 text-white">(10 Referrals required )</p>
                <div class="d-flex mb-2 justify-content-between">
                  <p class="m-0">Ended</p>
                  <p class="m-0">9:00 AM 07/18</p>
                </div>
                <div class="d-flex justify-content-between">
                  <p class="m-0 text-white">
                    <img
                      src="../assets/Ethereum-icon-purple.png"
                      alt="Ethereum Icon"
                      class="m-0 d-inline w-auto"
                    /><span>0.001</span>
                  </p>
                  <p class="m-0 text-white">1 PER WALLET</p>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <div class="w-50 d-flex flex-column justify-content-between">
                <p class="m-0 w-100 text-white" @click="changeMintType('earlybird')">
                  <input type="radio" id="earlybird" name="mintType" value="earlybird"><label for="earlybird" class="ms-2"><strong>Early-Bird</strong></label>
                </p>
                <p class="m-0 w-100 text-end text-white pe-5">400</p>
              </div>
              <div class="w-50 text-end px-2">
                <p class="mb-2 text-white">(5 Referrals required )</p>
                <div class="d-flex mb-2 justify-content-between">
                  <p class="m-0">Ended</p>
                  <p class="m-0">9:00 AM 07/18</p>
                </div>
                <div class="d-flex mb-2 justify-content-between">
                  <p class="m-0 text-white">
                    <img
                      src="../assets/Ethereum-icon-purple.png"
                      alt="Ethereum Icon"
                      class="m-0 d-inline w-auto"
                    /><span>0.01</span>
                  </p>
                  <p class="m-0 text-white">1 PER WALLET</p>
                </div>
              </div>
            </div>
            <router-link :to="mintThis" class="mint-btn mt-5 mb-2">Mint</router-link>
            <div class="d-flex justify-content-between w-100 text-white">
              <p class="text-white">Total Minted (0%)</p>
              <p class="text-white">0</p>
            </div>
          </div>
        </div>
        <div
          class="d-flex justify-content-center align-items-center gap-5 my-3"
        >
          <div class="wallet-brand">
            <img src="../assets/MetaMask.png" alt="MetaMask" />
          </div>
          <div class="wallet-brand">
            <img src="../assets/TrustWallet.png" alt="Trust Wallet" />
          </div>
          <div class="wallet-brand">
            <img src="../assets/WalletConnect.png" alt="WalletConnect" />
          </div>
        </div>
        <div
          class="d-flex justify-content-center align-items-center gap-5 my-3"
        >
          <div class="wallet-brand">
            <img src="../assets/Exodus.png" alt="Exodus" />
          </div>
          <div class="wallet-brand">
            <img src="../assets/SafePal.png" alt="SafePal" />
          </div>
        </div>
      </div>
      <div
        class="d-flex flex-column flex-md-row justify-content-between align-items-center mt-5"
      >
        <div class="w-100 w-md-50 p-0 pe-md-5">
          <p class="p-0 pe-md-5">
            In stages, GOLD will issue a total of 20,000 GSG (Gold Striker Gold)
            memberships. Unlike GSR (Gold Striker Regular), this qualification
            allows GSG to refer businesses to join the GOLD app through their
            network development, thereby becoming The Global Exclusive Marketing
            Agent (GEMA), associated with that business' ID.
          </p>
        </div>
        <div class="tokens-table w-100 w-md-50">
          <div class="tokens-table-head">Early-stage GEMA Tokens*</div>
          <div class="tokens-row bg-white">
            <div>First 1000 Miners</div>
            <div>
              <img
                src="../assets/Ethereum-icon-purple.png"
                alt="Ethereum Icon"
                class="m-0 d-inline w-auto"
              /><span>0.06</span>
            </div>
          </div>
          <div class="tokens-row bg-gray">
            <div>Next 2000 Miners</div>
            <div>
              <img
                src="../assets/Ethereum-icon-purple.png"
                alt="Ethereum Icon"
                class="m-0 d-inline w-auto"
              /><span>0.09</span>
            </div>
          </div>
          <div class="tokens-row bg-white">
            <div>Next 6000 Miners</div>
            <div>
              <img
                src="../assets/Ethereum-icon-purple.png"
                alt="Ethereum Icon"
                class="m-0 d-inline w-auto"
              /><span>0.12</span>
            </div>
          </div>
          <div class="tokens-row bg-gray">
            <div>Next 9800 Miners</div>
            <div>
              <img
                src="../assets/Ethereum-icon-purple.png"
                alt="Ethereum Icon"
                class="m-0 d-inline w-auto"
              /><span>0.15</span>
            </div>
          </div>
          <div class="d-flex gap-1 mt-2">
            <span>*</span
            ><span
              >Discounted rate is limited to FIRST 20,000 Miners. Rates are in
              Ethereum.</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mintThis: "nft-all-gema?type=og",
    };
  },
  methods: {
    changeMintType(mintType) {
      this.mintThis = "nft-all-gema?type=" + mintType;
    },
  },
};
</script>

<style scoped>
.nft-content {
  p {
    color: #07050a;
    font-size: 1.3rem;
    line-height: 2rem;
  }
}
.nft-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  .btn {
    height: 16vw;
    max-height: 62px;
    width: 100%;
    border-radius: 16vw;
    font-size: 6vw;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .GSG-btn {
    background: linear-gradient(to right, #ef8200, #ffe65a);
  }
  .GEMA-btn {
    background: linear-gradient(to right, #06a5ff, #3dde91);
  }
}
.nft-token-section {
  background-color: #07050a;
  border-radius: 1rem;
  padding: 1rem;
  font-size: 1.3rem;
  h1 {
    color: #f8fffe;
    font-size: 2rem;
    margin: 1rem 0;
  }
  h5 {
    color: #f8fffe;
    font-size: 1rem;
    margin: 1rem 0;
  }
  p {
    color: #6c6f83;
    font-size: 0.95rem;
    line-height: 1.4rem;
  }
  .mint-btn {
    width: 100%;
    height: 16vw;
    max-height: 62px;
    border-radius: 16vw;
    font-size: 6vw;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: linear-gradient(to right, #06a5ff, #3dde91);
  }
  .wallet-brand {
    height: 50px;
    width: auto;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.tokens-table {
  border-radius: 1rem;
  .tokens-table-head {
    background: linear-gradient(to right, #ef8200, #ffe65a);
    font-size: 1.5rem;
    color: white;
    box-sizing: border-box;
    padding: 0.5rem 1rem;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }
  .tokens-row {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    font-size: 1.3rem;
    span {
      vertical-align: middle;
    }
  }
  .bg-gray {
    background-color: #f1f3fb;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .nft-btns {
    flex-wrap: nowrap;
    .btn {
      width: 50%;
      font-size: 24px;
    }
  }
  .nft-token-section {
    .mint-btn {
      font-size: 24px;
    }
  }
}
</style>
